// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"e056e4f1","453":"557506a9","731":"f1cd3435"}[chunkId] + ".chunk.js";
};